import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GalaxyConfirmationModalModule } from '@vendasta/galaxy/confirmation-modal';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { RetailSummary, RetailSummaryComponent } from '@galaxy/inventory-ui';
import { getRetailSummaryFromOrder } from '../../shared/utils';
import { Order } from '@vendasta/sales-orders';

export interface SubmitForChargeDialogData {
  order: Order;
}

@Component({
  templateUrl: './submit-for-charge-dialog.component.html',
  styleUrls: ['./submit-for-charge-dialog.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatCheckboxModule,
    MatButtonModule,
    FormsModule,
    MatIconModule,
    GalaxyConfirmationModalModule,
    ProductAnalyticsModule,
    RetailSummaryComponent,
  ],
})
export class SubmitForChargeDialogComponent {
  confirmRetailCharge = false;
  confirmWholesaleCharge = false;

  retailSummary: RetailSummary;

  constructor(
    public dialogRef: MatDialogRef<SubmitForChargeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SubmitForChargeDialogData,
  ) {
    this.retailSummary =
      getRetailSummaryFromOrder(data.order) ||
      ({
        subtotal: 0,
        taxAmount: 0,
        firstPayment: 0,
        currencyCode: 'USD',
      } as RetailSummary);
  }

  chargeAndSubmit() {
    this.dialogRef.close(true);
  }
}
